import React, { useEffect } from 'react';

function Drawer({ open, onClose, children }) {
    useEffect(() => {
        if (!open) return;
        const handleKey = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="drawer-overlay" role="dialog" aria-modal="true" onClick={onClose}>
            <div className="drawer" onClick={(e) => e.stopPropagation()}>
                <div className="drawer-header">
                    <div className="brand">Menü</div>
                    <button
                        className="menu-button"
                        aria-label="Navigation schließen"
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
}

export default Drawer;
